const o = {
  "shadow-1": "0px 1px 10px 0px rgba(0, 0, 0, 0.04)",
  "shadow-2": "0px 1px 16px 0px rgba(0, 0, 0, 0.06)",
  "shadow-3": "0px 4px 24px 0px rgba(0, 0, 0, 0.06)",
  "shadow-4": "0px 4px 40px 0px rgba(0, 0, 0, 0.06)"
}, a = {
  "shadow-1": {
    backgroundColor: "$shadow-background",
    shadowColor: "$shadow-1-color",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 10,
    elevationAndroid: 0
    // Android specific shadow property
  },
  "shadow-2": {
    backgroundColor: "$shadow-background",
    shadowColor: "$shadow-2-color",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevationAndroid: 0
    // Android specific shadow property
  },
  "shadow-3": {
    backgroundColor: "$shadow-background",
    shadowColor: "$shadow-3-color",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevationAndroid: 0
    // Android specific shadow property
  },
  "shadow-4": {
    backgroundColor: "$shadow-background",
    shadowColor: "$shadow-4-color",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevationAndroid: 0
    // Android specific shadow property
  }
};
export {
  o as shadows,
  a as shadowsMobile
};
